import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Verifikasi Akun Company")
], -1)
const _hoisted_3 = { class: "table-custom verifikasi mb-3" }
const _hoisted_4 = { class: "row-header" }
const _hoisted_5 = { class: "text-xs font-normal color-blue-grey" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Button = _resolveComponent("Button")
  const _component_PaginatorUrl = _resolveComponent("PaginatorUrl")
  const _component_Card = _resolveComponent("Card")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              placeholder: "Cari Disini ...",
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              canClick: true,
              onSubmitInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitSearch(_ctx.inputSearch))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitSearch(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("table", _hoisted_3, [
          _createVNode("tr", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col, key) => {
              return (_openBlock(), _createBlock("th", { key: key }, [
                _createVNode("p", _hoisted_5, _toDisplayString(col.title), 1)
              ]))
            }), 128))
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (val, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: index,
              class: `row-content row-group`
            }, [
              _createVNode("td", null, [
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.nameEmpty(val.Fullname)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.nameEmpty(val.Kota)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.nameEmpty(val.Kode)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.nameEmpty(val.Email)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.nameEmpty(val.PhoneNumber)), 1)
              ]),
              _createVNode("td", null, [
                _createVNode(_component_Button, {
                  label: "Verifikasi Akun",
                  onClick: ($event: any) => (_ctx.goToDetail(val)),
                  class: "font-semibold p-button-sm btn-primary verifikasi"
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128))
        ]),
        _createVNode("div", null, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_PaginatorUrl, {
                key: 0,
                onOnPage: _ctx.onPage,
                totalRecords: _ctx.totalRecords.count
              }, null, 8, ["onOnPage", "totalRecords"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}